(function () {
  if (window.__steppedVariantInit) return;
  window.__steppedVariantInit = true;

  function getContainer(el) {
    return el.closest('.stepped-variant');
  }

  function getState(container) {
    if (!container._steppedState) {
      container._steppedState = {
        variants: JSON.parse(container.querySelector('script[data-variants]').textContent),
        steps: [...container.querySelectorAll('[data-step]')],
        selections: {},
        currentStep: 0
      };
    }
    return container._steppedState;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-step-trigger]');
    if (!trigger) return;

    var container = getContainer(trigger);
    if (!container) return;

    trigger.hidden = true;
    trigger.closest('[data-step]').querySelector('[data-step-options]').hidden = false;
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.type !== 'radio') return;

    var container = getContainer(input);
    if (!container) return;

    var state = getState(container);
    state.selections[input.name] = input.value;

    // Update variant ID
    var optionNames = state.steps.map(function (step) {
      return step.querySelector('[data-step-trigger]').dataset.optionName;
    });

    var match = state.variants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        var name = optionNames[i];
        return !state.selections[name] || state.selections[name] === opt;
      });
    });

    if (match) {
      var form = container.closest('form');
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;
      }
    }

    // Hide current step and advance to next step or show ATC
    state.steps[state.currentStep].hidden = true;

    if (state.currentStep < state.steps.length - 1) {
      state.currentStep++;
      state.steps[state.currentStep].hidden = false;
    } else {
      // Auto-submit when all options are selected (saves one click)
      var atcButton = container.querySelector('[data-atc-button]');
      if (atcButton) atcButton.click();
    }
  });

  // The <product-recommendations> custom element uses this.closest('.shopify-section')
  // to resolve its section ID for the recommendations API call. When the cart drawer is
  // shown as a dialog, the Drawer base class moves it out of the .shopify-section wrapper
  // (for z-index stacking). The theme's CartDrawer caches sectionId in connectedCallback
  // before the move, but <product-recommendations> runs loadRecommendations after the
  // move — closest() returns null, the fetch silently fails, and the element stays hidden.
  //
  // Fix: cache the section ID on page load (while the drawer is still in the wrapper)
  // and provide a fallback that loads recommendations when the built-in mechanism fails.

  var _drawerSectionId = (function () {
    // Try traversing from the drawer element first
    var el = document.querySelector('cart-drawer');
    var section = el && el.closest('.shopify-section');
    if (section) return section.id.replace('shopify-section-', '');
    // Fallback: find the cart-drawer section wrapper directly in the DOM
    // (the drawer may already have been moved out of it by the Drawer base class)
    section = document.querySelector('.shopify-section--cart-drawer[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : null;
  })();

  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!_drawerSectionId || !cart || !cart.item_count) return;

    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      var rec = drawer.querySelector('product-recommendations[hidden]');
      if (!rec || rec.childElementCount > 0) return;

      var productId = rec.getAttribute('product');
      if (!productId) return;

      fetch(Shopify.routes.root + 'recommendations/products'
        + '?product_id=' + productId
        + '&limit=' + (rec.getAttribute('limit') || 4)
        + '&section_id=' + _drawerSectionId
        + '&intent=' + (rec.getAttribute('intent') || 'related'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('product-recommendations');
          if (source && source.childElementCount > 0) {
            rec.replaceChildren.apply(rec,
              Array.from(document.importNode(source, true).childNodes));
            rec.hidden = false;
          }
        })
        .catch(function () {});
    }, 500);
  });
})();
